import TagField from './component';

export default TagField;
